import { ElementType } from "react";

export default class InputElement {

  public id?: number | string;
  public name: string;
  public type?: string;
  public value?: string;
  public isRequired: boolean;
  public isReadOnly: boolean;
  public helpText?: string;
  public as?: ElementType<any>;
  public options?: Array<string>;
  public className?: string;

  constructor(name: string, type: string, isRequired: boolean, isReadOnly: boolean, className?: string, helpText?: string, value?: string, as?: ElementType<any>, options?: Array<string>) {
    this.id = name;
    this.name = name;
    this.type = type;
    this.value = value;
    this.isRequired = isRequired;
    this.isReadOnly = isReadOnly;
    this.helpText = helpText;
    this.as = as;
    this.options = options;
    this.className = className;
  }

}
